export default "__VITE_ASSET__Du9sSG_8__"